import type { CSSProperties } from 'react';
import type { ModalClassNames } from './ModalProvider';

/**
 * The new design's dialog widths, as a stacked modal's panel classes. Every class is `new:`, so classic keeps the
 * width its opener gives; `!` outweighs an opener's inline width and max-width, and the cap keeps a narrow window's
 * margin.
 */
const FIT = 'new:max-w-[calc(100vw-2rem)]!';

export const DIALOG_448: ModalClassNames = { panel: `new:w-[448px]! ${FIT}` };
export const DIALOG_480: ModalClassNames = { panel: `new:w-[480px]! ${FIT}` };
/** The width of a dialog the boards draw at no other. */
export const DIALOG_560: ModalClassNames = { panel: `new:w-[560px]! ${FIT}` };
export const DIALOG_720: ModalClassNames = { panel: `new:w-[720px]! ${FIT}` };
export const DIALOG_960: ModalClassNames = { panel: `new:w-[960px]! ${FIT}` };

/**
 * A dialog both designs draw at one width, whose opener gives classic none of its own. The cap is repeated at `sm:`,
 * where the modal's own panel lifts every max-width.
 */
const BOTH_DESIGNS_FIT = 'max-w-[calc(100vw-2rem)] sm:max-w-[calc(100vw-2rem)]';

export const BOTH_DESIGNS_DIALOG_640: ModalClassNames = { panel: `w-[640px] ${BOTH_DESIGNS_FIT}` };
export const BOTH_DESIGNS_DIALOG_800: ModalClassNames = { panel: `w-[800px] ${BOTH_DESIGNS_FIT}` };
export const BOTH_DESIGNS_DIALOG_900: ModalClassNames = { panel: `w-[900px] ${BOTH_DESIGNS_FIT}` };

/** A record picker's dialog in both designs: as wide as the window allows, up to its table's width. */
export const PICKER_DIALOG_STYLE: CSSProperties = { width: '90vw', maxWidth: '1200px' };
